import classes from "./ButtonLink.module.css";

const ButtonLink = (props) => {
  return (
    <button className={`${classes.button} ${props.className}`}>
      <a href={props.src} target="_blank" rel="noreferrer">
        {props.label}
      </a>
    </button>
  );
};

export default ButtonLink;
